export default __webpack_public_path__ + "assets/images/8ee28254d35fb7a3409a61a53e762272.png";